/*
 * @Description: 登录相关
 * @Author: PF
 * @Date: 2022-11-15 10:27:02
 * @LastEditors: PF
 * @LastEditTime: 2025-11-18 17:47:43
 */
// 编译秘钥
export function urlencode (str) {
  str = (str + '').toString()
  return encodeURIComponent(str).replace(/!/g, '%21').replace(/'/g, '%27').replace(/\(/g, '%28')
    .replace(/\)/g, '%29').replace(/\*/g, '%2A').replace(/%20/g, '+')
}
// 返回登录页
export function backToLogin () {
  $cookies.remove(process.env.VUE_APP_BASE_TOKEN)
  localStorage.clear()
  sessionStorage.clear()
  const secret = process.env.VUE_APP_BASE_SSO_SECRET
  const url = process.env.VUE_APP_BASE_SSO_DOMAIN + '/getauthcode?secret=' + urlencode(secret)
  window.location.href = url
}
// 退出返回登录页
export function backToLogout () {
  $cookies.remove(process.env.VUE_APP_BASE_TOKEN)
  localStorage.clear()
  sessionStorage.clear()
  const secret = process.env.VUE_APP_BASE_SSO_SECRET
  const url = process.env.VUE_APP_BASE_SSO_DOMAIN + '/logout/' + secret
  window.location.href = url
}
